import { Constructor } from './constructor.type';
import { DynamicProperty } from '../decorators/dynamic-property.decorator';

export interface IDynamicFileAttributesMixin {
  maxFileBytes: number;
  allowedFileTypes: string;
}
export type DynamicFileAttributesCtor = Constructor<IDynamicFileAttributesMixin>;

export function mixinDynamicFileAttributes<T extends Constructor<{}>>(base: T): DynamicFileAttributesCtor & T {
  class DynamicFileAttributesMixin extends base implements IDynamicFileAttributesMixin {
    @DynamicProperty() maxFileBytes!: number;
    @DynamicProperty() allowedFileTypes!: string;

    constructor(...args: any[]) {
      super(...args);
    }
  }

  return DynamicFileAttributesMixin;
}
